import React, { useContext, useEffect, useState } from "react";
import { Songs } from "../../../Context/ContextApp";
export default function ListSongs() {
  const {ListSongs, handleSelectSong, song} = useContext(Songs)
  const [idSong, setidSong] = useState(0)
  const handlePlaySong = (idSong) => {
    handleSelectSong(idSong)
    setidSong(idSong)
  }
  useEffect(() => {
    setidSong(song.id)
  }, [song])
  const songActive = 'bg-slate-600 text-teal-300'
  return (
    <div className="col-span-2 bg-slate-800 overflow-hidden  overflow-y-scroll">
      <table className="table-auto w-full relative">
        <thead className="sticky top-0 h-12 text-white bg-slate-700">
          <th className="w-[10%] min-w-[30px]">#</th>
          <th className="w-[60%] text-left">Title</th>
          <th className="w-[20%]">Author</th>
          <th className="w-[10%]">
            <i className="fa fa-download"></i>
          </th>
        </thead>
        <tbody className="mt-4 h-full">
          {ListSongs.map((song, index) => (
            <tr className={`hover:bg-slate-600 h-12 ${idSong === index && songActive}`} 
              onClick={() => handlePlaySong(song.id)}
            >
              <td className=" text-center">{index + 1}
              </td>
              <td>{song.name}</td>
              <td className=" text-center">{song.author}</td>
              <td className="text-center">
                <a href={song.url}>
                  <i className="fa fa-download"></i>
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
